import { z } from 'zod';
import { AdminUserFieldsSchema } from '@shared/schemas/admin-users-teams';

// userType stays a plain string: AdminUserTypes buckets an unknown type into
// MEMBER, so a type the server added before this bundle shipped must not fail
// the whole list.
//
// `useAdminUsers` caches this under ['admin', 'users'], a key AdminUserTypes
// and AdminRoles share. AdminUsers.tsx reads the same endpoint under the same
// key unvalidated via UserSummary, so whichever queryFn ran last owns the
// cache: no .transform(), renamed, or dropped field without checking it, and
// don't reuse this schema or key for a different response shape.
//
// The field list is `AdminUserFieldsSchema` (`@shared/schemas/admin-users-teams`),
// shared with the server's admin-users responses; `userType` is loosened, and
// `deactivatedInSfdc` is kept because AdminUsers.tsx reads it from this same
// cache entry (zod would strip it, flashing departed users in the Teams pickers).
export const AdminUsersListResponseSchema = z.object({
  users: z.array(AdminUserFieldsSchema.extend({ userType: z.string(), deactivatedInSfdc: z.boolean() })),
});

export type AdminUsersListUser = z.infer<typeof AdminUsersListResponseSchema>['users'][number];
